import { CookieDetails } from "./Cookiebot";

export const cookiesRequiredForCategory = (
  category: keyof CookieDetails,
  cookieDetails: CookieDetails = window.static_data.cookie_details
): boolean => {
  return Object.keys(cookieDetails[category]?.subcategories ?? {}).length > 0;
};
